import React from "react";
import useSlider from "../../hooks/useSlider";
import ReducedTime from "../../assets/images/reducedTime.png";
import CustomeClearence from "../../assets/images/customeClearence.png";
import TimeTracking from "../../assets/images/timeTracking.png";
import SupplyChain from "../../assets/images/supplyChain.png";
import { Quote, Sparkles } from "lucide-react";

const testimonials = [
  {
    id: 1,
    quote: "Reduced export documentation processing time by 75% across all container shipments.",
    company: "Apex Ceramic Exports",
    stat: "600+ Containers Monthly",
    imageType: "warehouse",
  },
  {
    id: 2,
    quote: "Seamless customs clearance and error-free proforma invoicing on every single order.",
    company: "Vitrified Global Trade Co.",
    stat: "99.4% Compliance Rate",
    imageType: "dashboard",
  },
  {
    id: 3,
    quote: "Real-time vessel tracking and version history control transformed our logistics workflow.",
    company: "Pacific Ceramic Imports",
    stat: "45+ Destination Ports",
    imageType: "documents",
  },
  {
    id: 4,
    quote: "The single unified card system and dynamic Incoterms pricing saved our team hours daily.",
    company: "EuroConnect Freight Ltd.",
    stat: "35% Operational Cost Saved",
    imageType: "map",
  },
];

const imageMap = {
  warehouse: ReducedTime,
  dashboard: CustomeClearence,
  documents: TimeTracking,
  map: SupplyChain,
};

export const FeatureSlider = () => {
  const { currentIndex, goToSlide, setIsPaused } = useSlider(
    testimonials.length,
  );

  return (
    <section id="solutions" className="bg-white py-20 border-b border-slate-200 text-slate-900">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center space-y-3 mb-14">
          <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-amber-100 border border-amber-200 text-amber-800 text-xs font-bold uppercase">
            <Sparkles className="w-3.5 h-3.5 text-amber-600" />
            <span>Proven Enterprise Performance</span>
          </div>
          <h2 className="text-3xl sm:text-4xl font-bold tracking-tight text-slate-900">
            Trusted By Leading Exporters & Freight Houses
          </h2>
          <p className="text-sm text-slate-600 max-w-xl mx-auto">
            Discover how ceramics manufacturers and global trade leaders streamline shipping operations.
          </p>
        </div>

        <div
          className="relative overflow-hidden rounded-3xl bg-slate-50 border border-amber-200/80 p-2 shadow-sm"
          onMouseEnter={() => setIsPaused(true)}
          onMouseLeave={() => setIsPaused(false)}
        >
          <div
            className="flex transition-transform duration-500 ease-in-out"
            style={{ transform: `translateX(-${currentIndex * 100}%)` }}
          >
            {testimonials.map((testimonial) => (
              <div key={testimonial.id} className="w-full flex-shrink-0 p-4 sm:p-8">
                <div className="flex flex-col lg:flex-row items-center gap-8">
                  <img
                    src={imageMap[testimonial.imageType]}
                    alt={`${testimonial.company} success visual`}
                    className="w-32 h-32 lg:w-44 lg:h-44 object-cover border border-amber-200 rounded-2xl bg-white p-2 shadow-sm"
                  />
                  <div className="flex-1 text-center lg:text-left space-y-4">
                    <Quote className="h-8 w-8 text-amber-500/40 mx-auto lg:mx-0" />
                    <blockquote className="text-xl sm:text-2xl font-bold text-slate-900 leading-snug">
                      "{testimonial.quote}"
                    </blockquote>
                    <div className="flex items-center justify-center lg:justify-start gap-4 pt-2">
                      <div className="w-11 h-11 bg-amber-100 border border-amber-200 rounded-xl flex items-center justify-center text-amber-800 font-bold text-sm">
                        {testimonial.company.substring(0, 2).toUpperCase()}
                      </div>
                      <div>
                        <p className="font-bold text-sm text-slate-900">{testimonial.company}</p>
                        <p className="text-xs font-bold text-amber-700">{testimonial.stat}</p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>

        {/* Carousel Indicators */}
        <div className="flex justify-center gap-2 mt-8">
          {testimonials.map((_, index) => (
            <button
              key={index}
              onClick={() => goToSlide(index)}
              className={`h-2 rounded-full transition-all duration-300 ${
                currentIndex === index
                  ? "bg-amber-600 w-8"
                  : "bg-slate-300 hover:bg-slate-400 w-2"
              }`}
              aria-label={`Go to slide ${index + 1}`}
            />
          ))}
        </div>
      </div>
    </section>
  );
};

export default FeatureSlider;
